<template>
	<div class="about">
		<div class="pg-header">
			<div>
				<label class="title">健商统计</label>
			</div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>统计管理</span>|
					<span style="color: #699ce4;">健商统计</span>
				</div>
			</div>
		</div>

		<div class="collapse-wrap">
			<div class="search-bar">
				<el-form ref="form" label-width="120px">
					<div class="def-key">
						<label>入院时间
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px"
								type="daterange" align="right" unlink-panels range-separator="至"
								start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.date"
								:picker-options="pickerOptions" @change="handleFilter(0, $event)"></el-date-picker>
						</label>
						<div style="display: inline-block;">科室
							<el-select size="small" filterable clearable v-model="filter.depId" placeholder="请选择"
								@change="handleFilter(1, $event)">
								<el-option v-for="item in deptList" :key="item.id" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
						</div>
						<div style="display: inline-block;">机构
							<el-select size="small" filterable clearable v-model="filter.orgId" placeholder="请选择"
								@change="handleFilter(1, $event)">
								<el-option v-for="item in orgList" :key="item.id" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
						</div>
						<el-button size="mini" icon="el-icon-search" round @click="handleFilter">搜索</el-button>
						<el-button v-if="permission" class="btn-export flr" size="mini" round @click="exportReport"><i class="icon-export" style="margin-right: 10px;"></i>导出</el-button>
					</div>
				</el-form>
			</div>

			<div class="table-wrap">
				<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border
					show-summary :summary-method="getSummaries" :data="list.data" v-loading="isLoading"
					@selection-change="selectionChange">
					<el-table-column prop="depName" label="科室" width="180"></el-table-column>
					<el-table-column prop="inTotal" label="入院健商人次"></el-table-column>
					<el-table-column prop="outTotal" label="出院健商人次"></el-table-column>
					<el-table-column prop="twoTotal" label="两项完成人次"></el-table-column>
					<el-table-column prop="validRate">
						<template slot="header">
							有效健商评估率
							<img @click="openModal('header1')" class="t-img" src="../../assets/images/question-fill.png" alt="">
						</template>
						<template slot-scope="scope">
							<span>{{ scope.row.validRate}}</span>
							<img  @click="openModal('column1',scope.row)" class="t-img" src="../../assets/images/question-fill.png" alt="">
						</template>
					</el-table-column>
					<el-table-column prop="avgUpTotal" label="健商提升人次"></el-table-column>
					<el-table-column>
						<template slot="header">
							提升率
							<img @click="openModal('header')" class="t-img" src="../../assets/images/question-fill.png" alt="">
						</template>
						<template slot-scope="scope">
							<span>{{ scope.row.healthQuotientUpRate}}</span>
							<img  @click="openModal('column',scope.row)" class="t-img" src="../../assets/images/question-fill.png" alt="">
						</template>
					</el-table-column>
					<el-table-column prop="inAvgScore" label="入院健商平均分"></el-table-column>
					<el-table-column prop="outAvgScore" label="出院健商平均分"></el-table-column>
					<el-table-column prop="upAvgScore" label="平均分提升"></el-table-column>
					<el-table-column prop="inLe60Total" label="入院测评<60分人次"></el-table-column>
					<el-table-column prop="outLe60Total" label="出院测评<60分人次"></el-table-column>
					
				</el-table>
				<div class="pagination">
					<el-row>
						<el-col :span="12">
							<div class="record">当前是第<span
									v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span
									v-text="(filter.pageNumber-1)*filter.pageSize+filter.pageSize"></span>数据</div>
							<div class="record">总计<span v-text="list.total"></span>条记录</div>
						</el-col>
						<el-col :span="12" style="text-align: right;">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next"
								:page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]" prev-text="上一页" next-text="下一页"
								:current-page="list.current" :page-size="filter.pageSize" :total="list.total"
								@size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
						</el-col>
					</el-row>
				</div>
			</div>

		</div>
		<ModalCommon :dlg.sync="dlg" v-if="dlg.visible" />

	</div>
</template>

<script>
	import api from '@/service/api.js';
	import mixin from '@/views/mixin';
	import dayjs from 'dayjs';

	import ModalCommon from './components/modalCommon.vue';
	import questionFillImg from '@/assets/images/question-fill.png';

	export default {
		mixins: [mixin],
		components:{ModalCommon},
		data() {
			return {
				list: {
					current: 1,
					total: 0,
					pageSize: 0,
					data: null,
					summary: []
				},
				filter: {
					finishTimeEnd:'',
					finishTimeStart:'',
					depId: '',
					pageNumber: 1,
					pageSize: 10,
					date:[]
				},
				deptList: [],
				permission: false,
				orgList:[],
				dlg:{
					visible:false,
					type:'',
					propname:'HQ',
					data:{},
				},
			}
		},
		created() {
			// 获取 科室下拉
			api.getDeptDropdown({
				departmentType: 0
			}).then((res) => {
				if (res.code == 1000 && res.data) {
					this.deptList = res.data;
				}
			})
			// 获取机构下拉
			api.getListComboboxOrg().then((res)=>{
				if(res.code==1000){
					this.orgList=res.data;
				} else {
					this.$message.error(res.message)
				}
			})
			
		},
		mounted(){
			const now = dayjs();
			const firstDayOfMonth = dayjs().startOf('month');
			this.filter.finishTimeStart = firstDayOfMonth.format('YYYY-MM-DD HH:mm:ss');
			this.filter.finishTimeEnd=now.format('YYYY-MM-DD HH:mm:ss');
			this.filter.date=[this.filter.finishTimeStart,this.filter.finishTimeEnd];
			this.loadList();
		},
		methods: {
			async loadList() {
				this.isLoading = true;
				let res = await api.listHealthQuotientReport(this.filter);
				if (res.code == 500) {
					return this.$router.push({
						name: 'Login',
						query: {
							r: location.href
						}
					});
				}

				this.list.total = +res.total;
				this.list.current = this.filter.pageNumber;
				this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
				if (res.code == 1000 && res.data) {
					this.list.summary = ['合计', res.data.sum.inTotal,res.data.sum.outTotal,res.data.sum.twoTotal,res.data.sum.validRate,res.data.sum.avgUpTotal,res.data.sum.healthQuotientUpRate, res.data.sum.inAvgScore,res.data.sum.outAvgScore, res.data.sum.upAvgScore,res.data.sum.inLe60Total,  res.data.sum.outLe60Total];
					this.list.data = res.data.list;
				}
				// 权限控制
				this.user = JSON.parse(localStorage.getItem('user')).data;
				this.permission = (this.user.user.roleId == "6" || this.user.user.roleId == "1") ? true : false;
				this.isLoading = false;
			},
			getSummaries() {
				if (this.$refs['multipleTable']) {
					let current = this.$refs['multipleTable']
					let tbodyElement = current.$el.querySelector('tbody.has-gutter');
					if (tbodyElement) {
						let trElements = tbodyElement.querySelectorAll('tr');
						let img1 = document.querySelector('.img1');
						let img2 = document.querySelector('.img2');

						trElements.forEach(tr => {
							let tdElements = tr.querySelectorAll('td');
							tdElements.forEach((td, index) => {
								let divElement = td.querySelector('.cell');

								if (divElement && !(img1 || img2 ) && (index == 4||index==6)) {
									let imgElement = document.createElement('img');
									imgElement.src = questionFillImg;

									if (index == 4) {
										imgElement.className = 'img1';
										imgElement.addEventListener('click', () =>this.openSumModal('column1'));
									} else if (index == 6) {
										imgElement.className = 'img2';
										imgElement.addEventListener('click', () =>this.openSumModal('column'));
									}
									divElement.appendChild(imgElement);
								}
							});

						});
					} else {
						console.error('无法找到<tbody>元素！');
					}
				}
				this.$nextTick(() => {
					this.$refs['multipleTable'].doLayout();
				});
				return this.list.summary;
			},
			openSumModal(type){
				this.dlg.type=type;
				if(type=='column'){
					this.dlg.data.healthQuotientUpRate=this.list.summary[6]
					this.dlg.data.avgUpTotal=this.list.summary[5]
					this.dlg.data.twoTotal=this.list.summary[3]
				}else if(type=='column1'){
					this.dlg.data.validRate=this.list.summary[4]
					this.dlg.data.twoTotal=this.list.summary[3]
					this.dlg.data.inTotal=this.list.summary[1]
				}
				this.dlg.visible = true;
			},
			// 过滤条件 更改
			handleFilter(key, val) {
				switch (key) {
					case 0:
						console.log(this.filter.date,'=============this.filter.inHospitalDataEnd')
						if (this.filter.date) {
							this.filter.finishTimeStart = dayjs(this.filter.date[0]).format('YYYY-MM-DD 00:00:00');
							this.filter.finishTimeEnd = dayjs(this.filter.date[1]).format('YYYY-MM-DD 23:59:59');
						} else {
							this.filter.finishTimeStart = '';
							this.filter.finishTimeEnd = '';
						}
						break;
				}
				this.filter.pageNumber = 1;
				this.loadList();
			},
			handleSizeChange(v) {
				this.filter.pageSize = v;
				this.filter.pageNumber = 1;
				this.loadList();
			},
			handleCurrentChange(v) {
				this.filter.pageNumber = v;
				this.loadList();
			},
			exportReport() {
				this.filter.pageSize=this.list.total;
				let url = api.exportlListHealthQuotient(this.filter);
				const tempLink = document.createElement('a');
				tempLink.style.display = 'none';
				tempLink.href = url;
				tempLink.target = '_blank';
				document.body.appendChild(tempLink);
				tempLink.click()
				document.body.removeChild(tempLink);
				this.filter.pageSize=10;

			},
			openModal(type,data){
				this.dlg.data = data;
				this.dlg.type = type;
				this.dlg.visible = true;
			}
		}
	}
</script>

<style lang="less" scoped>
	@import '@/assets/style/var';
	@import './components/sty.less';

	.fc {
		cursor: pointer;
	}
</style>